export default __webpack_public_path__ + "static/APA_M_H_POS_RGB_180-cf70de4e4de949038a656029c849e209.png";